@import "../../packages/shared/scss";

$drawer-width: (
  "mobile": 100%,
  "m": p-px-to-rem(336px),
  "l": p-px-to-rem(405px),
  "xxl": p-px-to-rem(606px),
  "default": p-px-to-rem(330px),
);

:host {
  .phn-nd-contextual-drawer {
    float: right;
    left: -1000px;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    height: 100vh;
    z-index: $phn-z-index-mega-flyout + 1;

    @include pds-media-query-min-max("base", "s") {
      width: map-get($drawer-width, "mobile");
      border-radius: 0;
      background-color: $main-drawer-mobile-background-color;
    }

    @include pds-media-query-min("s") {
      width: 43.5%;
      border-radius: 0;
      background-color: $main-drawer-mobile-background-color;
    }

    @include pds-media-query-min("m") {
      width: 33%;
    }

    @include pds-media-query-min("xxl") {
      max-width: map-get($drawer-width, "xxl");
    }

    &.slide-in-from-left {
      animation: slide-in-from-left-absolute 600ms;
    }

    &.slide-out-to-left {
      animation: slide-in-from-left-absolute 600ms reverse;
    }

    .contextual-drawer-backdrop {
      position: fixed;
      z-index: $phn-z-index-mega-flyout;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0);
      opacity: 0;
      cursor: pointer;
      @include pds-frosted-glass();

      &.fade-in-animation {
        animation: fade-in-animation 400ms;
      }

      &.fade-out-animation {
        animation: fade-in-animation 400ms reverse;
      }
    }

    .close-button {
      position: absolute;
      right: p-px-to-rem(-70px);
      top: p-px-to-rem(10px);
      z-index: $phn-z-index-mega-flyout + 1;

      @include pds-media-query-min-max("base", "s") {
        display: none;
      }
    }

    .contextual-drawer {
      background-color: $main-drawer-background-color;
      position: relative;
      overflow-y: auto;
      overflow-x: hidden;
      border-radius: 0 4px 4px 0;
      height: 100vh;
      z-index: $phn-z-index-mega-flyout + 1;
    }
  }
}
